import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { InstallationDetail, getInstallationDetail } from '../api/services';
import './RecordDetail.css';

export default function RecordDetail() {
  const { recordId } = useParams();
  const [data, setData] = useState<InstallationDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (recordId) {
      loadDetail();
    }
  }, [recordId]);

  const loadDetail = async () => {
    try {
      const result = await getInstallationDetail(recordId!);
      setData(result);
    } catch (err) {
      setError('Unable to load this installation.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!data) return <div className="error">Record not found</div>;

  return (
    <div className="record-detail">
      <div className="page-header"><h2>Installation detail</h2><p>{data.clientId}</p></div>
      <div className="detail-grid">
        <section className="card"><h3>Client</h3><dl><div><dt>Status</dt><dd><span className={`badge badge-${data.status === 'active' ? 'success' : 'danger'}`}>{data.status}</span></dd></div><div><dt>Version</dt><dd>{data.clientVersion || 'Unknown'}</dd></div><div><dt>Platform</dt><dd>{data.platform || 'Unknown'} / {data.architecture || 'Unknown'}</dd></div><div><dt>Locale</dt><dd>{data.locale || 'Unknown'}</dd></div><div><dt>Last seen</dt><dd>{data.lastSeenAt ? new Date(data.lastSeenAt).toLocaleString() : 'Never'}</dd></div></dl></section>
        <section className="card"><h3>Activity totals</h3><div className="detail-metrics"><div><strong>{data.session_count}</strong><span>Sessions</span></div><div><strong>{data.tips_shown}</strong><span>Tips shown</span></div><div><strong>{data.tutorial_runs}</strong><span>Tutorial runs</span></div></div></section>
      </div>
      <section className="card"><h3>Capabilities</h3><div className="capability-list">{Object.entries(data.capabilities || {}).map(([key, value]) => <span key={key} className={value ? 'capability enabled' : 'capability'}>{key}: {String(value)}</span>)}</div></section>
      <section className="card"><h3>Recent tutorials</h3>{data.recentTutorials.length === 0 ? <p className="muted">No tutorial runs recorded for this installation.</p> : <div className="recent-tutorials">{data.recentTutorials.map((tutorial) => <div key={tutorial.id}><div><strong>{tutorial.title}</strong><span>{tutorial.appName} · {new Date(tutorial.startedAt).toLocaleString()}</span></div><span className={`badge badge-${tutorial.status === 'completed' ? 'success' : tutorial.status === 'failed' ? 'danger' : 'warning'}`}>{tutorial.status}</span></div>)}</div>}</section>
    </div>
  );
}
